import React, { useState } from 'react';
import { Alert, Box, Button, Container, Stack, TextField, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

// Hardcoded client-side check to stop students from casually generating quiz
// codes themselves. Not real auth (credentials are visible in the bundle) -
// replace with backend-verified auth before this matters for anything else.
//
// Mounted as a layout route wrapping every host/* route (see App.js), so
// adding a new host route guards it for free instead of requiring each page
// to remember to wrap itself.
const STORAGE_KEY = 'quiz.hostAuthed';

function HostAuthGate() {
    const [authed, setAuthed] = useState(() => sessionStorage.getItem(STORAGE_KEY) === 'true');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    if (authed) {
        return <Outlet />;
    }

    const submit = (e) => {
        e.preventDefault();
        if (username === 'admin' && password === 'admin') {
            sessionStorage.setItem(STORAGE_KEY, 'true');
            setAuthed(true);
        } else {
            setError('Wrong username or password.');
        }
    };

    return (
        <Container maxWidth="xs" sx={{ py: 8 }}>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>Host sign-in</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
                Please enter the user pass.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            <Box component="form" onSubmit={submit}>
                <Stack spacing={2}>
                    <TextField
                        label="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                    />
                    <TextField
                        label="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button type="submit" variant="contained" size="large">Sign in</Button>
                </Stack>
            </Box>
        </Container>
    );
}

export default HostAuthGate;
